import logo from './logo.svg';
import React, {createContext, useState, useEffect} from "react";
import './App.css';
import Navbar from './components/Navbar';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './screens/Home';
import SignUp from './components/SignUp';
import SignIn from './components/SignIn';
import Profile from './screens/Profile';
import ProfileOptions from './screens/ProfileOptions';
import Creator from './screens/Creator';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Createpost from './screens/Createpost';
import Notifications from './screens/Notifications';
import CreateMoment from './screens/CreateMoment';
import MomentViewer from './screens/MomentViewer';
import { LoginContext } from './context/LoginContext';
import Modal from './components/Modal';
import UserProfile from './components/UserProfile';
import MyFollowingPost from './screens/MyFollowingPost';
import { GoogleOAuthProvider } from '@react-oauth/google';
import SearchPage from './screens/SearchPage';
import ChatPage from './screens/ChatPage';
import ExplorePage from './screens/ExplorePage';
import io from 'socket.io-client';
import HomePostOptions from './screens/HomePostOptions';

function App() {
  const [userLogin, setUserLogin] = useState(false);
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    // initialization helper used at mount and when user changes
    const initSocketAndCounts = () => {
      const token = localStorage.getItem('jwt');
      const user = JSON.parse(localStorage.getItem('user') || 'null');
      // clear caches for new user
      window.__unreadCounts = {};
      window.__notifCount = 0;
      if (!token || !user) {
        window.dispatchEvent(new CustomEvent('unread-updated'));
        window.dispatchEvent(new CustomEvent('notif-updated'));
        return;
      }

      // create socket if doesn't exist
      if (!window.__socket) {
        window.__socket = io('/');
        window.__socket.on('connect', () => {
          window.__socket.emit('setup', user._id);
        });
      } else {
        window.__socket.emit('setup', user._id);
      }

      // fetch unread counts
      fetch('/conversations/unread', { headers: { Authorization: 'Bearer ' + token } })
        .then(r => {
          if (r.status === 401) {
            localStorage.removeItem('jwt');
            localStorage.removeItem('user');
            return;
          }
          return r.json();
        })
        .then(list => {
          if (!list) return;
          const serverMap = {};
          (list || []).forEach(item => { serverMap[item._id] = item.count; });
          window.__unreadCounts = window.__unreadCounts || {};
          Object.keys(serverMap).forEach(k => {
            window.__unreadCounts[k] = Math.max(window.__unreadCounts[k] || 0, serverMap[k]);
          });
          window.dispatchEvent(new CustomEvent('unread-updated'));
        }).catch(()=>{ window.__unreadCounts = window.__unreadCounts || {}; window.dispatchEvent(new CustomEvent('unread-updated')); });

      // fetch notifications
      fetch('/notifications', { headers: { Authorization: 'Bearer ' + token } })
        .then(r => {
          if (r.status === 401) {
            localStorage.removeItem('jwt');
            localStorage.removeItem('user');
            return;
          }
          return r.json();
        })
        .then(list => {
          if (!list) return;
          const count = (list || []).filter(n => !n.read).length;
          window.__notifCount = count;
          window.dispatchEvent(new CustomEvent('notif-updated'));
        }).catch(()=>{ window.__notifCount = 0; window.dispatchEvent(new CustomEvent('notif-updated')); });

      // ensure global dedup set exists
      window.__seenMessages = window.__seenMessages || new Set();

      // global newMessage listener (attach once, dedupe handlers)
      const handleNewMessage = (msg) => {
        if (!msg || !msg._id) return;
        if (window.__seenMessages.has(msg._id)) return;
        window.__seenMessages.add(msg._id);

        const convId = msg.conversation ? (msg.conversation._id || msg.conversation) : null;
        if (!convId) return;
        const senderId = msg.sender && msg.sender._id;
        if (senderId && senderId === user._id) return; // ignore own messages

        const active = window.__activeConversation;
        if (active && active.toString() === convId.toString()) {
          // user is viewing this conversation – nothing to increment
        } else {
          window.__unreadCounts = window.__unreadCounts || {};
          window.__unreadCounts[convId] = (window.__unreadCounts[convId] || 0) + 1;
          window.dispatchEvent(new CustomEvent('unread-updated', { detail: { conversationId: convId } }));
        }
      };

      // new notification event
      const handleNotif = (notif) => {
        window.__notifCount = (window.__notifCount || 0) + 1;
        window.dispatchEvent(new CustomEvent('notif-updated'));
      };

      // follow changed handler -> notify interested UI to refresh mutuals/conversations
      const handleFollowChanged = (data) => {
        window.dispatchEvent(new CustomEvent('follow-changed', { detail: data }));
      };

      // attach socket handlers (remove previous handlers if present)
      try {
        if (window.__socket) {
          if (window.__globalMessageHandler) window.__socket.off('newMessage', window.__globalMessageHandler);
          if (window.__globalNotifHandler) window.__socket.off('newNotification', window.__globalNotifHandler);
          if (window.__globalFollowHandler) window.__socket.off('followChanged', window.__globalFollowHandler);

          window.__socket.on('newMessage', handleNewMessage);
          window.__socket.on('newNotification', handleNotif);
          window.__socket.on('followChanged', handleFollowChanged);

          window.__globalMessageHandler = handleNewMessage;
          window.__globalNotifHandler = handleNotif;
          window.__globalFollowHandler = handleFollowChanged;
        }
      } catch (e) {}
    };

    // run on mount
    initSocketAndCounts();

    // re-run when app receives a user-changed event (login/logout)
    const userChangedHandler = () => initSocketAndCounts();
    window.addEventListener('user-changed', userChangedHandler);
    return () => window.removeEventListener('user-changed', userChangedHandler);

  }, []);
  return (
    <BrowserRouter>
      <div className="App">
      <GoogleOAuthProvider clientId="288414574089-ub66qjbq2tmag4gp021pm33ltfs93vii.apps.googleusercontent.com">
        <LoginContext.Provider value={{ setUserLogin, setModalOpen }}>
          <Navbar login={userLogin} />
          <Routes>
            <Route path='/' element={<Home/>}></Route>
            <Route path='/signup' element={<SignUp/>}></Route>
            <Route path='/signin' element={<SignIn/>}></Route>
            <Route exact path='/profile' element={<Profile/>}></Route>
            <Route path='/profile/options' element={<ProfileOptions/>}></Route>
            <Route path='/profile/home-post-options' element={<HomePostOptions/>}></Route>
            <Route path='/profile/creator' element={<Creator/>}></Route>
            <Route path='/createPost' element={<Createpost/>}></Route>
            <Route path='/profile/:userid' element={<UserProfile/>}></Route>
            <Route path='/followingpost' element={<MyFollowingPost/>}></Route>
            <Route path='/search' element={<SearchPage/>}></Route>
            <Route path='/explore' element={<ExplorePage/>}></Route>
            <Route exact path='/chatpage' element={<ChatPage/>}></Route>
            <Route path='/notifications' element={<Notifications/>}></Route>
            <Route path='/moment/:id' element={<MomentViewer/>}></Route>
            <Route path='/createMoment' element={<CreateMoment/>}></Route>
            <Route path='/notifications' element={<Notifications/>}></Route>
            <Route path='/createMoment' element={<CreateMoment/>}></Route>
            <Route path='/moment/:id' element={<MomentViewer/>}></Route>
          </Routes>
          <ToastContainer theme="dark" />
          {modalOpen && <Modal setModalOpen={setModalOpen}></Modal>}
        </LoginContext.Provider>
        </GoogleOAuthProvider>
      </div>
    </BrowserRouter>
  );
}

export default App;
